'use client'

import { Button, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  PRIVACY_CONTACT_URL,
  PRIVACY_POLICY_URL,
} from '@marketplace-web/user-agreements/privacy-center-data'

const PrivacyBottomSection = () => {
  const translate = useTranslate('privacy_center.bottom_section')

  return (
    <section className="privacy-center__bottom-section">
      <h2 className="privacy-center__bottom-section-title">{translate('title')}</h2>
      <div className="privacy-center__bottom-cta">
        <Button
          size={Button.Size.Default}
          theme="primary"
          styling={Button.Styling.Filled}
          inverse
          text={translate('read_policy_cta')}
          url={PRIVACY_POLICY_URL}
          testId="privacy-center__bottom-section-cta"
          aria={{ 'aria-labelledby': translate('read_policy_cta') }}
        />
        <Spacer size={Spacer.Size.Large} />
        <Button
          size={Button.Size.Default}
          theme="primary"
          styling={Button.Styling.Outlined}
          inverse
          text={translate('contact_us_cta')}
          url={PRIVACY_CONTACT_URL}
          testId="privacy-center__bottom-section-cta"
          aria={{ 'aria-labelledby': translate('contact_us_cta') }}
        />
      </div>
    </section>
  )
}

export default PrivacyBottomSection
